// extracted by mini-css-extract-plugin
export var structure = "style-module--structure--bce44";
export var structure__block = "style-module--structure__block--42832";
export var structure__blocks = "style-module--structure__blocks--8701e";
export var structure__content = "style-module--structure__content--4e734";
export var structure__sliderUndertext = "style-module--structure__slider-undertext--48b92";
export var structure__text = "style-module--structure__text--55414";
export var structure__textItem = "style-module--structure__text-item--360fa";
export var structure__textItemItem = "style-module--structure__text-item-item--8d382";
export var structure__title = "style-module--structure__title--44154";